import { Collapse, Descriptions, Tag, Tooltip } from 'antd'
import React from 'react'
import * as RankApi from '../../api/rank/rankApi';

import './CustomerResultCard.scss'
import { NO_DATA, URL_RANK } from '../../env';
import { info_cicrle, none_rank } from '../ExportImgFigma';
import { NO_VIEW } from '../../services/data';
import { capitalizeEachWord } from '../../until';


interface props {
    dataCardCustomer?: RankApi.ISearchCardCustomer
}


const OverViewCardCustomerV2: React.FC<props> = ({
    dataCardCustomer
}) => {

    const infoCustomer = dataCardCustomer?.infoCustomer
    const infoRank = dataCardCustomer?.infoRank
    return (
        <div className='custom-page-css w-full h-full border rounded overflow-hidden'>
            <div className='custom-page-css w-full bg-096DD9'
                style={{
                    padding: '4px 12px'
                }}
            >
                <span className='custom-page-css w-full  text-white font-regular text-base'

                >
                    Thông tin cá nhân
                </span>
            </div>



            <div className='custom-page-css w-full h-full flex flex-col gap-2'
                style={{
                    padding: '4px 12px'
                }}
            >
                <ItemRenderTooltip label='Số điện thoại' array={infoCustomer?.listPhone} />
                <ItemRenderTooltip label='Email' array={infoCustomer?.listEmail} />
                <ItemRenderTooltipAddress label='Địa chỉ' array={infoCustomer?.listAddress} />
              <ItemRender label={'Loại điều kiện xếp hạng'} value={infoRank?.type === 1 ? 'Theo tổng chi tiêu' : 'Theo chi tiêu mua xe và dịch vụ'} />
                {infoRank?.type === 2 && <ItemRender label={'Logic kết hợp các điều kiện lọc'}
                    value={`Thỏa mãn tất cả các điều kiện (${infoRank?.logicOperator}) `} />}



            </div>
        </div>
    )
}

export default OverViewCardCustomerV2

interface ItemRenderProps {
    label: string;
    value?: any;
}

const ItemRender: React.FC<ItemRenderProps> = ({
    label,
    value,
}) => (
    <div className="custom-page-css flex items-center justify-between">
        <span className="text-344054 font-medium text-sm">
            {label}
        </span>

        <span className="text-344054 font-regular text-sm">
            {value ?? NO_DATA}
        </span>
    </div>
);


interface ItemRenderPropsTooltip {
    label: string;
    array?: any[];
}

const ItemRenderTooltip: React.FC<ItemRenderPropsTooltip> = ({
    label,
    array,
}) => (
    <div className="custom-page-css flex items-center justify-between ">
        <span className="text-344054 font-medium text-sm">
            {label}
        </span>
        <div className="custom-page-css flex items-center  gap-2">

            <span className="text-344054 font-regular text-sm">
                {/* {infoCustomer?.permissions?.username ? infoCustomer?.userName?.find((item: any) => item.isPrimary === 1)?.username : NO_VIEW} */}
                {capitalizeEachWord(array && array.length > 0 ? array[0] : NO_VIEW)}
            </span>
            <div className="custom-page-css flex items-center gap-2">
                {
                    (array?.length ?? 0) > 1 ?
                        <Tooltip
                            placement="right"
                            color="white"
                            title={
                                <div
                                    style={{
                                        maxHeight: 400,       // chiều cao cố định
                                        overflowY: "auto",    // bật scroll dọc
                                    }}
                                    className="space-y-2"
                                >
                                    {
                                        array?.map((item: any, i: any) => (
                                            <div key={i} className="flex items-center gap-2">
                                                <span className="color-bage-custom fs-14">

                                                    {capitalizeEachWord(item)}
                                                </span>
                                            </div>
                                        ))
                                    }
                                </div>
                            }
                        >
                            <div className="action-icons action-icons-bage-2 fs-14 cursor-pointer ">
                                <img src={info_cicrle} alt="Avatar" />
                            </div>
                        </Tooltip> :
                        ''
                }
            </div>
        </div>
    </div>
);


interface ItemRenderPropsTooltipAddress {
    label: string;
    array?: any[];
}

const ItemRenderTooltipAddress: React.FC<ItemRenderPropsTooltipAddress> = ({
    label,
    array,
}) => (
    <div className="custom-page-css flex items-center justify-between ">
        <span className="text-344054 font-medium text-sm">
            {label}
        </span>
        <div className="custom-page-css flex items-center  gap-2">

            <span className="text-344054 font-regular text-sm">
                {/* {infoCustomer?.permissions?.username ? infoCustomer?.userName?.find((item: any) => item.isPrimary === 1)?.username : NO_VIEW} */}
                {capitalizeEachWord(array && array.length > 0 ? array[0]?.fullAddress : NO_VIEW)}
            </span>
            <div className="custom-page-css flex items-center gap-2">
                {
                    (array?.length ?? 0) > 1 ?
                        <Tooltip
                            placement="right"
                            color="white"
                            title={
                                <div
                                    style={{
                                        maxHeight: 400,       // chiều cao cố định
                                        overflowY: "auto",    // bật scroll dọc
                                    }}
                                    className="space-y-2"
                                >
                                    {
                                        array?.map((item: any, i: any) => (
                                            <div key={i} className="flex items-center gap-2">
                                                <span className="color-bage-custom fs-14">

                                                    {item.fullAddress}
                                                </span>
                                            </div>
                                        ))
                                    }
                                </div>
                            }
                        >
                            <div className="action-icons action-icons-bage-2 fs-14 cursor-pointer ">
                                <img src={info_cicrle} alt="Avatar" />
                            </div>
                        </Tooltip> :
                        ''
                }
            </div>
        </div>
    </div>
);

